<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div class="pa-4">
    <div class="d-flex">
      <h2>{{ title }}</h2>
      <v-spacer />
      <v-btn
        icon
        @click="closeDialog"
      >
        <v-icon large>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <v-divider class="my-4" />
    <div
      v-if="!errorExist"
    >
      <div
        :class="{ 'grey lighten-2': dragover }"
        class="mx-6 py-6"
        style="border-radius: 15px; border: dashed 1px grey; "
        @drop.prevent="onDrop"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
      >
        <div
          v-if="!selectFile"
          class="text-center my-4"
        >
          <v-icon
            size="60"
          >
            mdi-cloud-upload
          </v-icon>
        </div>

        <div
          v-else
        >
          <template
            v-if="noErrorLog"
          >
            <div style="display: grid; grid-template-columns: 3fr 3fr; grid-column-gap: 48px">
              <div
                class="d-flex align-center justify-center flex-column"
              >
                <div style="max-height: 100%">
                  <div class="text-center mb-8">
                    <v-icon
                      size="80"
                    >
                      mdi-file-excel
                    </v-icon>
                  </div>
                  <div>
                    {{ selectFile.name }}
                  </div>
                </div>
              </div>
              <div style="max-height: 250px; overflow: scroll">
                <template v-if="fileType === 'dish'">
                  <div class="font-weight-bold mt-2">
                    {{ $t('numberOfNewAddDish') }}{{ newCategoryCount }}
                  </div>
                  <div class="font-weight-bold mt-2">
                    {{ $t('numberOfNewAddPrinter') }} {{ newPrinterCount }}
                  </div>
                  <div class="font-weight-bold mt-2">
                    {{ $t('NewlyAddedAllergens') }}: {{ newAllergyCount }}
                  </div>
                  <div class="font-weight-bold mt-2">
                    {{ $t('numberOfNewAddDishes') }} {{ newDishCount }}
                  </div>
                </template>
                <template v-else>
                  <div class="font-weight-bold mt-2">
                    {{ $t('NewlyAddedAttributeGroups') }}: {{ newAttributeGroupCount }}
                  </div>
                  <div class="font-weight-bold mt-2">
                    {{ $t('NewlyAddedAttributes') }}: {{ newAttributeCount }}
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex flex-column align-center justify-center">
              <div class="d-flex flex-column">
                <v-icon
                  color="red"
                  size="80"
                >
                  mdi-close
                </v-icon>
                <div class="text-h4 mb-2">
                  {{ $t('FileIsNotAllowedAfterTest') }}
                </div>
              </div>

              <div
                style="max-height: 150px; overflow: scroll;width: 80%"
              >
                <div v-if="codeText.length !== 0">
                  <div class="d-flex align-center justify-center">
                    <div>
                      {{ $t('no') }} {{ codeText }} {{ $t('OK') }} 'Product Number' {{ $t('DataException') }}
                    </div>
                    <v-spacer />
                    <div>
                      {{ $t('DataExceptionHint') }}
                    </div>
                  </div>
                </div>
                <div
                  v-for="i in log"
                  :key="i.id"
                  class="mt-1 d-flex align-center justify-center"
                >
                  <div>
                    {{ $t('no') }} {{ i.index + 5 }} {{ $t('OK') }} {{ i.value }} {{ $t('DataException') }}
                  </div>
                  <v-spacer />
                  <div>
                    {{ $t('returnReason') }}: {{ i.reason }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div
          style="position: relative"
        >
          <div class="d-flex justify-center">
            <p
              class="pa-4"
              v-html="$t('wayToUploadFile')"
            />
          </div>
          <div style="width: 100%;">
            <v-file-input
              ref="input"
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              outlined
              style="opacity: 0; position: absolute; width: 100%; height: 120px; bottom: -70px; "
              type="file"
              @change="choseFile"
            />
          </div>
        </div>
      </div>

      <div
        class="text-center my-6"
      >
        <template v-if="fileType === 'dish'">
          <v-btn
            :href="downloadDishesFile"
            class="amber lighten-4 text--black"
            outlined
            width="95%"
          >
            {{ $t('DownloadImportTemplate') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            :href="downloadAttributeFile"
            class="amber lighten-4 text--black"
            outlined
            width="95%"
          >
            {{ $t('DownloadImportTemplate') }}
          </v-btn>
        </template>
      </div>
      <div
        v-if="noErrorLog"
        class="d-flex justify-center align-center absoluteBtn"
      >
        <v-btn
          :class="$vuetify.breakpoint.lgAndUp ? 'mr-4' : ' mr-2 text-h6'"
          color="amber lighten-4 black--text"
          elevation="0"
          width="50%"
          @click="uploadData"
        >
          {{ $t('importFile') }}
        </v-btn>
      </div>
    </div>

    <div
      v-else
      class="text-center"
    >
      <p class="text-h2 my-2">
        {{ $t('importFailed') }}
      </p>
      <div
        v-for="(error,index) in errors"
        :key="'error' + index "
        class="d-flex justify-start"
      >
        {{ error.row }} row: {{ error.message }}
      </div>

      <div class="my-6">
        <v-btn
          class="error"
          elevation="0"
          @click="closeDialog"
        >
          {{ $t('cancel') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import IKUtils from 'innerken-js-utils'
import {
  checkFileType,
  convertAttributeFileData,
  convertFileData,
  parseExcel,
  uploadAttribute,
  uploadDish
} from '@/model/controller/dishUpload/readFile'
import { uniqBy } from 'lodash'
import { GlobalConfigLang } from '@/model/global/GlobalSettings'
import i18n from '@/i18n'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'

export default {
  name: 'UploadPage',
  props: {
    fileType: {},
    title: {}
  },
  data () {
    return {
      codeText: [],
      log: [],
      downloadAttributeFile: 'file/属性组上传模板20231110.xlsx',
      downloadDishesFile: 'file/上传模板20231110.xlsx',
      clearDialog: false,
      selectFile: null,
      dragover: false,
      progress: 0,
      dragFileName: null,
      errors: [],

      categoryDict: {},
      printerDict: null,
      allergyDict: null,
      attributeGroup: null,
      attribute: null,
      dishList: []

    }
  },
  computed: {
    noErrorLog () {
      return this.log.length === 0 && this.codeText === ''
    },

    errorExist () {
      return this.errors.length > 0
    },

    newCategory () {
      return this.categoryDict
        ? Object.values(this.categoryDict)?.filter(it => it.add).map(item => {
          item.currentName = item.langs.find(i => i.lang === GlobalConfigLang.lang)
          return item
        })
        : []
    },
    newCategoryCount () {
      return this.newCategory.length
    },
    printerList () {
      return this.printerDict ? Object.values(this.printerDict) : []
    },
    newPrinter () {
      return this.printerList?.filter(it => it.add) ?? []
    },
    newPrinterCount () {
      return this.newPrinter.length
    },
    allergyList () {
      return this.allergyDict ? Object.values(this.allergyDict) : []
    },
    newAllergy () {
      return this.allergyList?.filter(it => it.add) ?? []
    },
    newAllergyCount () {
      return this.newAllergy.length
    },

    attributeList () {
      return this.attribute ? Object.values(this.attribute) : []
    },
    newAttribute () {
      return this.attributeList?.filter(it => it.add) ?? []
    },
    newAttributeCount () {
      return this.newAttribute.length
    },

    attributeGroupList () {
      return this.attributeGroup ? Object.values(this.attributeGroup) : []
    },
    newAttributeGroup () {
      return this.attributeGroupList?.filter(it => it.add) ?? []
    },
    newAttributeGroupCount () {
      return this.newAttributeGroup.length
    },
    newDish () {
      return this.dishList.map(item => {
        item.currentName = item.langs.find(i => i.lang === GlobalConfigLang.lang)
        return item
      }) ?? []
    },

    newDishCount () {
      return this.dishList.length
    }

  },
  methods: {
    choseFile (event) {
      this.selectFile = event
      this.getUploadFile(event)
    },
    onDrop (event) {
      this.dragover = false
      if (event.dataTransfer.files[0]) {
        this.selectFile = event.dataTransfer.files[0]
        this.getUploadFile(event.dataTransfer.files[0])
      }
    },

    async getUploadFile (file) {
      this.codeText = []
      this.log = []
      if (!(await checkFileType(file))) {
        IKUtils.showError('File is not *.xls or *.xlsx')
        this.selectFile = null
        return
      }
      this.selectFile = file
      const appearOnce = {}
      const priceCheck = /(^[0-9]\d*(\.\d{1,2})?$)/
      const taxList = (await CategoryType.getList(true)).flatMap(it => it.langs.map(it => it.name))
      const rawFileData = (await parseExcel(file)).map((row, index) => {
        for (const itKey in row) {
          if ((!row[itKey] && row[itKey] !== 0) && itKey !== 'Description' && itKey !== 'Allergy') {
            this.log.push({
              index,
              value: itKey,
              reason: i18n.t('ItemRequired') + '！'
            })
          }
          if (row[itKey] && row[itKey].toString().includes('，')) {
            this.log.push({
              index,
              value: itKey,
              reason: i18n.t('Use') + ' "，"'
            })
          }
        }
        if (!taxList.includes(row['Tax Type'])) {
          this.log.push({
            index,
            value: 'Tax Type',
            reason: this.$t('TaxTypeDoesNotExists')
          })
        }
        if (!priceCheck.test(row.Price)) {
          this.log.push({
            index,
            value: 'Price',
            reason: i18n.t('PriceCheckHint')
          })
        }
        const productNumber = row['Product Number']
        if (appearOnce[productNumber]) {
          this.codeText.push(index + 5)
        }
        appearOnce[productNumber] = true
        return row
      })
      this.log = uniqBy(this.log, it => it.index.toString() + '|' + it.value)
      this.codeText = this.codeText.join()
      console.log((await parseExcel(file)), 'data')
      if (this.fileType === 'dish') {
        const res = await convertFileData(rawFileData)

        if (res.state === 'bad') {
          this.errors = res.errors
        } else {
          [this.categoryDict, this.printerDict, this.dishList, this.allergyDict] = [...Object.values(res.fetchedData)]
        }
      } else {
        const res = await convertAttributeFileData(rawFileData)
        if (res.state === 'bad') {
          this.errors = res.errors
        } else {
          [this.attributeGroup, this.attribute] = [...Object.values(res.fetchedData)]
        }
      }
    },

    closeDialog () {
      this.selectFile = null
      this.errors = []
      this.dragFileName = null
      this.$emit('close')
      IKUtils.toast(this.$t('cancel_success'), 'info')
    },

    async uploadData () {
      if (this.fileType === 'dish') {
        if (this.newCategoryCount === 0 && this.newPrinterCount === 0 && this.newDishCount === 0 && this.newAllergyCount === 0) {
          IKUtils.showConfirm(i18n.t('NoItemNeedUploaded'), i18n.t('WARNING'))
          return
        }
        await uploadDish(this.categoryDict, this.printerDict, this.dishList, this.allergyDict)
      } else {
        // if (this.newAttributeCount === 0 && this.newAttributeGroupCount === 0) {
        //   IKUtils.showConfirm('There is no item needed to be uploaded', 'Warning')
        //   return
        // }
        await uploadAttribute(this.attributeGroup, this.attribute)
      }
      this.selectFile = null
      this.errors = []
      this.dragFileName = null
      this.$emit('close')
    }

  }

}
</script>

<style>
.absoluteBtn {
  position: sticky;
  height: 50px;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
